export default function PageAfspraken() {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold">Afspraken</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img 
                    src="/images\2025.05\Afspraken_Afspraken-origineel-transparant-cropped-h50.png"
                    alt="Artsenpraktijk Waarloos"
                />
                <h3 style={{ marginBottom: '0px'}}>Afspraken</h3>
            </div>
            <p>
                Wij werken enkel op afspraak.<br/>
                U kan online een afspraak boeken via onderstaande knop of telefonisch via het nummer 015/31.19.59.
                <br/> <br/>
                <a href="https://www.mtc-it4.be/patient/index.html#/softlogon/bjNkcWkyQmFRMkpDVTRFNndleFgzQVNGWExuditzcGhIMlUrNjdjRmVyVVhHekFGc2wxUnd5bndMTzVPKzVEbg==/group"
                   target="_blank"
                   rel="noopener noreferrer"
                >
                    <button>Maak een afspraak</button>
                </a>
            </p>
            <p>
                Indien u online geen vrije plaats meer kan vinden, contacteer ons dan telefonisch voor 12u30. <br/>
                Gelieve tussen 12u30 en 18u enkel te bellen voor dringende problemen die niet kunnen wachten tot de volgende voormiddag.
            </p>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                <img 
                    src="/images\2025.05\Afspraken_1PerPersoon-origineel-transparant-cropped-h50.png"
                    alt="Artsenpraktijk Waarloos"
                />
                <h3 style={{ marginBottom: '0px'}}>1 afspraak per persoon/ annulatie</h3>
            </div>
            <p>
                Wij voorzien 15 minuten per afspraak per patiënt, maak dus 1 afspraak per persoon.<br/>
                Kom op tijd en verwittig ons minimaal 2 uur op voorhand indien u uw afspraak niet kan nakomen. Breng steeds uw identiteitskaart mee. 
            </p>
            <p>
                Voor korte acute problemen zijn er ook afspraken van 10 minuten voorzien. Hier wordt 1 acuut probleem behandeld zoals bijvoorbeeld een nieuwe hoest, snot, verkoudheid, braken, koorts, ...                
            </p>
        </div>
    );
}